import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Header({ user, onLogout }) {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: '/', label: 'Dashboard' },
    { path: '/jobs', label: 'Offres' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('ts_token');
    localStorage.removeItem('ts_user');
    onLogout();
    navigate('/login');
  };

  return (
    <header style={{
      background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
      padding: '0 24px',
      display: 'flex',
      alignItems: 'center',
      height: 60,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    }}>
      <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ fontSize: 24 }}>&#9733;</span>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 20, letterSpacing: -0.5 }}>
          TalentSourcing
        </span>
      </Link>

      <nav style={{ marginLeft: 40, display: 'flex', gap: 4 }}>
        {navItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            style={{
              color: location.pathname === item.path ? '#fff' : '#94a3b8',
              textDecoration: 'none',
              padding: '8px 16px',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 500,
              background: location.pathname === item.path ? 'rgba(255,255,255,0.1)' : 'transparent',
              transition: 'all 0.2s',
            }}
          >
            {item.label}
          </Link>
        ))}
      </nav>

      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 16 }}>
        <span style={{ color: '#94a3b8', fontSize: 13 }}>{user}</span>
        <button
          onClick={handleLogout}
          style={{
            background: 'rgba(255,255,255,0.1)',
            border: '1px solid rgba(255,255,255,0.2)',
            color: '#e2e8f0',
            padding: '6px 14px',
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
        >
          Déconnexion
        </button>
      </div>
    </header>
  );
}

export default Header;
